import React, { useEffect, useRef } from 'react'
import { Calculator } from './styled-components'

export const BasicDesmosCalculator = ({ config }) => {
  const desmosBasicRef = useRef()

  useEffect(() => {
    const Desmos = window.Desmos
    if (desmosBasicRef.current && Desmos) {
      const desmosFourFunctionCalculator = Desmos.FourFunctionCalculator(
        desmosBasicRef.current,
        config
      )

      return () => {
        desmosFourFunctionCalculator.destroy()
      }
    }
  }, [config])

  return <Calculator id="demos-basic-calculator" ref={desmosBasicRef} />
}
